import { gql } from '@apollo/client';

/**
 * Notification system operations.
 * Mirrors promostork_backend/src/schema/notification (all @isAuth — callers
 * must skip these when there is no token, otherwise the Apollo errorLink
 * will bounce the user to /login).
 */

const NOTIFICATION_FIELDS = gql`
  fragment NotificationFields on Notification {
    id
    title
    description
    messageTitle
    messageBody
    entity
    type
    category
    priority
    channels
    data
    link
    imageUrl
    createdAt
  }
`;

export const LIST_USER_NOTIFICATIONS = gql`
  query ListUserNotifications($options: Options) {
    listUserNotifications(options: $options) {
      userNotifications {
        id
        isSeen
        readAt
        createdAt
        notification {
          ...NotificationFields
        }
      }
      pagination {
        totalRecords
        currentPage
        totalPages
        limit
      }
      unreadCount
    }
  }
  ${NOTIFICATION_FIELDS}
`;

export const UNREAD_NOTIFICATION_COUNT = gql`
  query UnreadNotificationCount {
    unreadNotificationCount
  }
`;

export const MY_NOTIFICATION_PREFERENCES = gql`
  query MyNotificationPreferences {
    myNotificationPreferences {
      id
      enabled
      locale
      categories {
        category
        channels
      }
      quietHours {
        enabled
        start
        end
        timezone
      }
    }
  }
`;

// MY_DEVICES removed: no call sites, and `myDevices` is a dashboard-only
// query that is not part of the public schema (PLAN.md T5.5).

export const MARK_NOTIFICATION_READ = gql`
  mutation MarkNotificationRead($id: ID!) {
    markNotificationRead(id: $id)
  }
`;

export const MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation MarkAllNotificationsRead {
    markAllNotificationsRead
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation DeleteNotification($id: ID!) {
    deleteNotification(id: $id)
  }
`;

export const REGISTER_DEVICE = gql`
  mutation RegisterDevice($input: RegisterDeviceInput!) {
    registerDevice(input: $input) {
      id
      token
      platform
      deviceId
    }
  }
`;

export const UNREGISTER_DEVICE = gql`
  mutation UnregisterDevice($token: String!) {
    unregisterDevice(token: $token)
  }
`;

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences($input: UpdatePreferencesInput!) {
    updateNotificationPreferences(input: $input) {
      id
      enabled
      locale
      categories {
        category
        channels
      }
      quietHours {
        enabled
        start
        end
        timezone
      }
    }
  }
`;
